export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9883.1874ac1d.jpg";